import { TestimonialsSectionQueryResult } from "@/sanity/schemas/lib/queries";

export function PerspectiveCard({
    perspective,
}: {
    perspective: TestimonialsSectionQueryResult["perspectives"][number];
}) {
    return (
        <div className="flex flex-col gap-6 md:flex-row md:gap-24">
            <div className="w-full md:w-1/4">
                <h4 className="text-lg font-semibold">{perspective.person.name}</h4>
                <p className="mt-1 text-sm text-white/50">{perspective.person.company}</p>
            </div>

            <div className="w-full md:w-3/4">
                <blockquote className="text-xl font-light leading-relaxed text-white/90 md:text-2xl">
                    &ldquo;{perspective.quote}&rdquo;
                </blockquote>
            </div>
        </div>
    );
}
